<template>
    <footer id="footer">
        <div class="footer-help">
            <a class="help-button" href="https://eurocajarural.es/oficinas" target="_blank">
                <span class="help-icon-Eurocaja">b</span>
                <span class="help-button-text">Oficinas y cajeros</span>
            </a>
            <a class="help-button" href="https://eurocajarural.es/atencioncliente" target="_blank">
                <span class="help-icon-Eurocaja">c</span>
                <span class="help-button-text">Atención al cliente</span>
            </a>
        </div>
        <div class="footer-social">
            <span>Síguenos</span>
            <a href="https://www.facebook.com/eurocajarural" target="_blank" class="icon">%</a>
            <a href="https://www.youtube.com/eurocajarural" target="_blank" class="icon">=</a>     
            <a href="https://twitter.com/eurocajarural" target="_blank" class="icon">3</a>    
            <a href="https://www.linkedin.com/company/eurocajarural/" target="_blank" class="icon">&</a>  
        </div>
        
    </footer>    
</template>


<script>
export default {
    name: 'FooterComponent'
}
</script>